/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import ReactPlayer from 'react-player';
import classNames from 'classnames';
import { BASE_URL, IMAGE_PATHS, VIDEO_PATHS } from '../../../../constants/paths.constants';
import { yellow, universalStyles } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  container: {
    width: 'calc(100% + 160px)',
    display: 'flex',
    flexDirection: 'row',
  },
  columnContainer: {
    width: '100%',
  },
  column0: {
    width: '3%',
  },
  column1: {
    width: '25%',
    marginRight: '1%',
  },
  column2: {
    width: '37%',
    marginRight: '1%',
  },
  column3: {
    width: '36%',
  },
  image: {
    width: '100%',
  },
  video: {
    maxHeight: 435,
    aspectRatio: '.48',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
  },
  figureBox: {
    border: `2px solid ${yellow}`,
    width: '100%',
    boxSizing: 'border-box',
    padding: '3px 5px',
    margin: '5px 0 10px',
  },
  paragraph: {
    marginTop: 15,
  },
  row: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  key: {
    width: '80%',
    marginLeft: 15,
  },
  text: {
    fontSize: 16,
    lineHeight: 1.2,
  },
}));

const Acquisition02 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.container}>
        <div className={classes.columnContainer}>
          <div className={classes.row}>
            <div className={classes.column0}>
              <img src={`${BASE_URL}${IMAGE_PATHS.SUV.path}`} alt={IMAGE_PATHS.SUV.alt} />
            </div>
            <div className={classes.column1}>
              <div className={classes.video}>
                <ReactPlayer className={classes.responsiveVideo} url={VIDEO_PATHS.ACQ_CASE_STUDY_2.path} controls />
              </div>
            </div>
            <div className={classes.column2}>
              <img
                className={classes.image}
                src={`${BASE_URL}${IMAGE_PATHS.POSITIVE_VERTEBRATE.path}`}
                alt={IMAGE_PATHS.POSITIVE_VERTEBRATE.alt}
              />
            </div>
            <div className={classes.column3}>
              <img
                className={classes.image}
                src={`${BASE_URL}${IMAGE_PATHS.POSITIVE_PROSTATE.path}`}
                alt={IMAGE_PATHS.POSITIVE_PROSTATE.alt}
              />
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.column0} />
            <div className={classes.column1}>
              <div className={classes.figureBox}>
                <Typography variant="body1" className={classes.text}>
                  <b>Fig 1: </b>
                  MIP (Click to Play)
                </Typography>
              </div>
            </div>
            <div className={classes.column2}>
              <div className={classes.figureBox}>
                <Typography variant="body1" className={classes.text}>
                  <b>Fig 2: </b>
                  Positive Vertebra T8 (thoracic spine)
                </Typography>
                <Typography variant="body1" className={classNames(classes.text, classes.paragraph)}>
                  CT (top) PET/CT Fusion (middle) and PET only (bottom) transaxial images
                </Typography>
                <Typography variant="body1" className={classNames(classes.text, classes.row)}>
                  <span className={classes.key}>
                    T8 Vertebra SUV(bw)
                    <sub>max</sub>:
                  </span>
                  11.5
                </Typography>
                <Typography variant="body1" className={classNames(classes.text, classes.row)}>
                  <span className={classes.key}>
                    Marrow (L3) SUV(bw)
                    <sub>mean</sub>:
                  </span>
                  3.2
                </Typography>
              </div>
            </div>
            <div className={classes.column3}>
              <div className={classes.figureBox}>
                <Typography variant="body1" className={classes.text}>
                  <b>Fig 3: </b>
                  Positive prostate – right apex and right mid zone (hip hardware)
                </Typography>
                <Typography variant="body1" className={classNames(classes.text, classes.paragraph)}>
                  PET only (top) and PET/CT (bottom) transaxial images
                </Typography>
                <Typography variant="body1" className={classNames(classes.text, classes.row)}>
                  <span className={classes.key}>
                    Prostate SUV(bw)
                    <sub>max</sub>:
                  </span>
                  9.2
                </Typography>
                <Typography variant="body1" className={classNames(classes.text, classes.row)}>
                  <span className={classes.key}>
                    Marrow (L3) SUV(bw)
                    <sub>mean</sub>:
                  </span>
                  3.2
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Acquisition02;
